import { render } from "./OrthoPartners.vue?vue&type=template&id=d6b12854"
import script from "./OrthoPartners.vue?vue&type=script&lang=js"
export * from "./OrthoPartners.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__